import React from 'react';

const MobileBottomNav = ({
  currentPage,
  onHome,
  onSearch,
  onCart,
  onDeals,
  onAccount,
  cartCount = 0,
}) => {
  const items = [
    { key: 'home', icon: 'fa-house', label: 'Home', onClick: onHome, active: currentPage === 'home' },
    { key: 'search', icon: 'fa-magnifying-glass', label: 'Search', onClick: onSearch, active: currentPage === 'search' },
    { key: 'cart', icon: 'fa-bag-shopping', label: 'Cart', onClick: onCart, count: cartCount, isCTA: true },
    { key: 'deals', icon: 'fa-tags', label: 'Deals', onClick: onDeals, active: currentPage === 'deals' },
    { key: 'account', icon: 'fa-user', label: 'Account', onClick: onAccount, active: currentPage === 'account' },
  ];

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-2px_12px_rgba(0,0,0,0.06)]"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="grid grid-cols-5 gap-0">
        {items.map((item) => (
          <li key={item.key}>
            <button
              onClick={item.onClick}
              data-testid={`bottom-nav-${item.key}`}
              className={`w-full flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${
                item.active ? 'text-cyan-700' : 'text-gray-500 hover:text-cyan-700'
              }`}
            >
              <div className="relative">
                {item.isCTA ? (
                  <div className="w-11 h-11 rounded-full bg-cyan-500 text-white flex items-center justify-center shadow-md -mt-4">
                    <i className={`fa-solid ${item.icon} text-lg`} />
                  </div>
                ) : (
                  <i className={`fa-solid ${item.icon} text-lg`} />
                )}
                {item.count > 0 && (
                  <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center">
                    {item.count > 99 ? '99+' : item.count}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-semibold ${item.isCTA ? 'mt-0' : ''}`}>{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
